//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//	module.component('baseCurrencies', {
//		templateUrl: 'views/components/views/baseCurrencies/baseCurrencies.template.html?v=' + module.version,
//		controllerAs: 'vm',
//		controller: ['baseCurrenciesService', function (baseCurrenciesService) {
//			const vm = this;

//			vm.model = {
//				itemsListBaseCurrencies: []
//			};

//            async function loadBaseCurrencies() {
//                vm.model.itemsListBaseCurrencies = await baseCurrenciesService.listBaseCurrencies();
//            }

//            vm.$onInit = function () {
//                loadBaseCurrencies();
//            }
//		}]
//	});
//})();
